import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const MiceEventsForm = (strings: any, eventTypes: any[], months: any[]): FormModel[] => {
  return [
    {
      label: strings.sales_management_branch_competitions_column_mice_event_type,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'eventType',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 4, sm: 4 },
      required: true,
      options: eventTypes,
    },
    {
      label: 'Event Subtype',
      value: '',
      size: 'medium',
      type: 'text',
      variant: 'outlined',
      placeholder: 'Enter event subtype',
      field: 'eventSubtype',
      validators: [],
      responsive: { xs: 12, md: 4, sm: 4 },
      required: false,
    },
    {
      label: strings.sales_management_branch_competitions_column_mice_event_date,
      placeholder: strings.sales_management_branch_competitions_column_mice_event_date,
      value: '',
      size: 'medium',
      type: 'select',
      isMulti: true,
      isClearable: true,
      variant: 'outlined',
      field: 'eventMonths',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 4, sm: 4 },
      required: true,
      options: months,
    },
    {
      label: strings.sales_management_branch_competitions_mice_event_pax,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'noOfPax',
      responsive: { xs: 6, sm: 6, md: 3 },
      required: false,
      validators: [],
    },
    {
      label: strings.sales_management_branch_competitions_mice_event_room_nights,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'roomNights',
      responsive: { xs: 6, sm: 6, md: 3 },
      required: false,
      validators: [],
    },
    {
      label: strings.sales_management_branch_competitions_mice_event_potential_revenue,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'potentialRevenue',
      responsive: { xs: 6, sm: 6, md: 3 },
      required: false,
      validators: [],
    },
    {
      label: strings.sales_management_branch_competitions_column_mice_event_reminder_days,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'reminderBeforeDays',
      responsive: { xs: 6, sm: 6, md: 3 },
      required: false,
      validators: [],
    },
  ];
};
